import { testimonials } from '@/mocks/site';

export default function Testimonials() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-accent-600">读者反馈 / FEEDBACK</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">他们看完之后说</h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
            这些话来自长期读者的真实反馈，我们只保留对方法本身的评价。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500" />
              <blockquote className="mt-4 flex-1 font-body text-sm leading-relaxed text-foreground-700">
                {item.text}
              </blockquote>
              <figcaption className="mt-6 border-t border-background-200 pt-4">
                <p className="font-heading text-sm font-semibold text-foreground-950">{item.name}</p>
                <p className="mt-1 font-label text-xs text-foreground-500">{item.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}